import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FetchAvatarFilterRequest} from "../../core/shared.actions";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../state/app.state";
import {avatarFilters} from "../../core/shared.selectors";
import {Subject, takeUntil} from "rxjs";

@Component({
  selector: 'app-avatar-panel',
  templateUrl: './avatar-panel.component.html',
  styleUrls: ['./avatar-panel.component.css']
})
export class AvatarPanelComponent implements OnInit {
  @Output() handleClick = new EventEmitter;
  @Input() selectedAvtar;
  avatarOptions = []
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store<fromRoot.State>,
  ) {
    this.store.dispatch(FetchAvatarFilterRequest());
  }

  ngOnInit(): void {
    this.store.select(avatarFilters)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (data?.avatarOptions?.length) {
          this.avatarOptions = JSON.parse(JSON.stringify(data?.avatarOptions));

          if (this.selectedAvtar) {
            this.avatarOptions.forEach((option) => {
              if (option.id === this.selectedAvtar.id) {
                option.isSelected = true;
              }
            })
          }
        }
      });
  }


  selectAvatar(avatar) {
    this.clearSelection();
    this.selectedAvtar = avatar;
    this.handleClick.emit(avatar);
    return;
  }

  clearSelection() {
    this.avatarOptions.forEach((option) => {
      option.isSelected = false;
    })
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}
